import React from 'react';
import PropTypes from 'prop-types';


function RsvpFormHeader({ page, guestGroupRsvp, wedding }) {
  let numEvents = 0;
  let numEventsRequiringRsvp = 0;
  if (guestGroupRsvp.events) {
    numEvents = guestGroupRsvp.events.length;
    numEventsRequiringRsvp = guestGroupRsvp.events.filter(event => event.collect_rsvps === true).length;
  }
  return (
    <div className={`cms-page-header${(!page.description && !page.header_image_url) || !page.title ? ' flex-container' : ''}`}>
      <div className="cms-header-accent-top-left" />
      <div className="cms-header-accent-top-right" />
      <div className="cms-header-accent-bottom-left" />
      <div className="cms-header-accent-bottom-right" />
      <h1 className="for-small-laptops">{page.title}</h1>
      {window.zola.env !== 'production' ? (
        <span>
          {page.header_image_url && (
            <img src={`${page.header_image_url}?h=400`} alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} className="img-responsive center-block" />
          )}
        </span>
      ) : (
        <span>
          {page.header_image_url && (
            <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
          )}
        </span>
      )}
      {page.description && (
        <p className={`page-description${page.header_image_url ? ' has-image-above' : ''}`}>{page.description}</p>
      )}
      <div className="hidden-xs">
        {numEvents > 0 && !guestGroupRsvp.success && (
          <p className="header-instructions">
            We have invited you to {numEvents} wedding {numEvents === 1 ? 'event' : 'events'}, {numEventsRequiringRsvp} of which {numEventsRequiringRsvp === 1 ? 'requires' : 'require'} your RSVP.<br />Be sure to scroll all the way down.
          </p>
        )}
        {numEvents > 0 && guestGroupRsvp.success && (
          <p>
            Thank you for your RSVP!
          </p>
        )}
      </div>
    </div>
  );
}

RsvpFormHeader.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string,
    header_image_url: PropTypes.string,
    description: PropTypes.string,
  }),
  guestGroupRsvp: PropTypes.shape({
    events: PropTypes.arrayOf(PropTypes.shape({})),
    success: PropTypes.bool
  }),
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
  })
};

export default RsvpFormHeader;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/RsvpFormHeader.jsx